import axios from "axios";
import {FILE_API_BASE_URL} from "./config";

const uploadFileToServer = async (file: File, onProgress: (percent: number) => void) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
        const response = await axios.post(
            FILE_API_BASE_URL + "/files/upload",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                onUploadProgress: (progressEvent) => {
                    const percent = Math.round(
                        (progressEvent.loaded * 100) / (progressEvent.total || 1)
                    );
                    // setProgress(percent);
                    onProgress(percent);
                    console.log(percent)
                },
            }
        );
        console.log("Upload success:", response.data);
    } catch (error) {
        console.error("Upload failed:", error);
    }
};


export const getChangedFile = async (file: File): Promise<File> => {
    const originalName = file.name;

    const extension = originalName.substring(originalName.lastIndexOf("."));
    const nameWithoutExtension = originalName.substring(
        0,
        originalName.lastIndexOf(".")
    );
    /* Renaming file */
    const now = new Date();
    const timestamp = `${now.getFullYear()}${String(
        now.getMonth() + 1
    ).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}_${String(
        now.getHours()
    ).padStart(2, "0")}${String(now.getMinutes()).padStart(2, "0")}${String(
        now.getSeconds()
    ).padStart(2, "0")}`;

    return new File(
        [file],
        `${nameWithoutExtension}_${timestamp}${extension}`,
        {
            type: file.type,
        }
    );
}


export default uploadFileToServer;